
import React, { useState, useEffect } from "react";

import "./asnGRN.css";
import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { authKey, GET_CONSIGNMENT_STATUS_LIST, GET_ASN_LIST, GET_STAKEHOLDER_CATEGORY } from '../../../common/URLs';
import Moment from 'moment';
import jwt from 'jwt-decode';
import SearchIcon from "@mui/icons-material/Search";
import moment from 'moment';
import { Container, Button, Box, TextField, Tooltip, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, CardContent, Grid, FormControl, InputLabel, Select } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PIT_ROLES, PROD } from "../../../common/constants";
import { toast } from 'react-toastify';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { CloseIcon, ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import { Helmet } from "react-helmet-async";
import { loaderService } from "../../../common/custom-loader/loader-service";
import CustomDataGridToolbarServer from "../../../common/customDataGridToolbarServer";
import dayjs from 'dayjs';

function AsnGrn() {

    const navigate = useNavigate();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const { state } = useLocation();
    const [tabValue, setTabValue] = React.useState(state?.tabValue ? state?.tabValue : 'RawBamboo');
    const [asnDetails, setAsnDetails] = useState([]);
    const [consignmentStatusList, setConsignmentStatusList] = useState();
    const [selected, setSelected] = useState(asnDetails);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [searchFilter, setSearchFilter] = useState({
        "consignmentStatus": "",
        "fromDate": null,
        "toDate": null
    });

    const [stakeholderDetails, setStakeholderDetails] = useState();
    const [searchText, setSearchText] = useState("");
    const [sortField, setSortField] = useState("CreatedOn");
    const [sortOrder, setSortOrder] = useState("desc");
    const [page, setPage] = useState(0); // current page
    const [pageSize, setPageSize] = useState(10); // rows per page
    const [rowCount, setRowCount] = useState(0); // total rows from API

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        setPage(0);
        setSearchText("");
        getAsnDetails(newValue, 0, pageSize, sortField, sortOrder, searchText);
    };

    const fetchSearchData = async (searchInput) => {
        setSearchText(searchInput);
        setPage(0);
        await getAsnDetails(tabValue, page, pageSize, sortField, sortOrder, searchInput);
    };
    const fetchData = async () => {
        return await getAsnDetails(tabValue, 0, 0, sortField, sortOrder, searchText);
    }

    useEffect(() => {
        getAsnDetails(tabValue, page, pageSize, sortField, sortOrder, searchText)
    }, [stakeholderDetails, localStorage.getItem('role')]);

    const onViewDetails = (cellValues) => {
        navigate('./AsnGrnViewDetails', {
            state: { selectedRow: cellValues.row, tabValue: tabValue }
        });
    }

    useEffect(() => {
        getConsignmentStatusList();
    }, []);

    const getConsignmentStatusList = () => {
        loaderService.showLoader()
        apiClient
            .post(
                GET_CONSIGNMENT_STATUS_LIST,
                {

                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setConsignmentStatusList(response.data.consignmentStatus);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        if (decoded.extension_URN) {
            getStakeDetails();
        }
    }, [decoded.extension_URN]);

    function getStakeDetails() {
        loaderService.showLoader()
        apiClient
            .post(GET_STAKEHOLDER_CATEGORY,
                {
                    "urn": decoded.extension_URN,
                    "type": ""
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setStakeholderDetails(response.data);
                loaderService.hideLoader()
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
                toast.error(error.message);
            });
    }

    const getAsnDetails = async (materialType, page, pageSize, sortField, sortOrder, searchText) => {
        let data = {
            "stakeholderUrn": decoded.extension_URN ? decoded.extension_URN : '',
            "stakeholderType": localStorage.getItem('role') === PIT_ROLES?.PlantSCMOperator ? "Plant" : getLocalStorageItem('role') === PIT_ROLES?.LLESCMOperator ? "LLE" : stakeholderDetails?.category,
            "consignmentStatus": searchFilter?.consignmentStatus ? searchFilter?.consignmentStatus : null,
            "asnFromDate": searchFilter?.fromDate ? searchFilter?.fromDate : null,
            "asnToDate": searchFilter?.toDate ? searchFilter?.toDate : null,
            "roleType": localStorage.getItem('role') ? localStorage.getItem('role') : '',
            "loginId": localStorage.getItem('InspectorEmail') ? localStorage.getItem('InspectorEmail') : '',
            "materialType": materialType ? materialType : tabValue,
            "pageNumber": page,
            "pageSize": pageSize,
            "filtertext": searchText ? searchText : ""
        }

        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader();
        return await apiClient
            .post(GET_ASN_LIST, data, { headers })
            .then((res) => {
                const list = res?.data?.asnList || [];
                setAsnDetails(list);
                setRowCount(res.data.rowCount || 0);
                loaderService.hideLoader();
                return list;
            })
            .catch((err) => {
                console.log(err);
                loaderService.hideLoader();
                toast.error(err?.message || "Error fetching ASN list");
                return [];
            });
        // loaderService.hideLoader();
    };

    const handleChange = (e) => {
        if (e.target.name === "consignmentStatus") {
            setSearchFilter({ ...searchFilter, "consignmentStatus": e.target.value })
        }
    }

    const handleDateChange = (value, dateField) => {
        setSearchFilter((prev) => {
            const formatted = value ? dayjs(value).format("YYYY-MM-DD") : null;

            // If user picks a toDate earlier than fromDate, auto-fix fromDate
            if (dateField === "toDate" && prev.fromDate && value) {
                if (dayjs(prev.fromDate).isAfter(value, "day")) {
                    return { ...prev, toDate: formatted, fromDate: formatted };
                }
            }

            return { ...prev, [dateField]: formatted };
        });
    };

    function searchAsnDetails(e) {
        e.preventDefault();
        getAsnDetails(tabValue, page, pageSize, sortField, sortOrder, searchText)
    }

    useEffect(() => {
        if (searchFilter?.fromDate === null & searchFilter?.toDate !== null) {
            toast.error("Please select ASN From Date and ASN To Date")
        }
        else getAsnDetails(tabValue, 0, pageSize, sortField, sortOrder, searchText);
    }, [searchFilter])

    function clearSearch(e) {
        e.preventDefault();
        setPage(0);
        setSearchText("");
        setSearchFilter({
            consignmentStatus: "",
            fromDate: null,
            toDate: null,
        })
    }

    const columns = [
        { field: 'asnNo', headerName: 'ASN ID#', width: 120 },
        { field: 'consignmentNo', headerName: 'Consignment No', width: 130 },
        { field: 'challanNo', headerName: 'Delivery Challan Number', width: 180 },
        { field: 'grnNo', headerName: 'GRN Number', width: 150 },
        { field: 'sesNo', headerName: 'SES Number', width: 150 },
        // { field: 'poNumber', headerName: 'PO Number', width: 150 },
        {
            field: 'stakeholderSourceUrn', headerName: 'Source URN', width: 150,
            renderCell: (params) => {
                return (
                    <>{params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceUrn}</>
                );
            },
            valueGetter: (params) => params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceUrn
        },
        {
            field: 'stakeholderSourceName', headerName: 'Source Name', width: 180,
            renderCell: (params) => {
                return (
                    <>{params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceName}</>
                );
            },
            valueGetter: (params) => params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceName
        },
        { field: 'consignmentDestinationStakeholderUrn', headerName: 'Destination URN', width: 150 },
        {
            field: 'consignmentDestinationName', headerName: 'Destination Name', width: 200,
            renderCell: (params) => {
                return (
                    <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                        {params.value}
                    </div>
                )
            },
            valueGetter: (params) => params.value
        },
        { field: 'consignmentOwnerName', headerName: 'Transporter Name', width: 250, hide: tabValue === "RawBamboo" },
        { field: 'consignmentStatus', headerName: 'Consignment Status', width: 220 },
        { field: 'asnStatus', headerName: 'ASN Status', width: 220 },
        {
            field: 'asnDate', headerName: 'ASN Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        {
            field: 'pickupNetWeight', headerName: 'ASN Quantity', width: 120,
        },
        { field: 'vehicleNumber', headerName: 'Vehicle Number', width: 180 },
        {
            field: 'actions', headerName: "Action", width: 150,
            renderCell: (cellValues) => {
                return (
                    <Tooltip title="View">
                        <IconButton
                            color="primary"
                            onClick={() => onViewDetails(cellValues)}
                        >
                            <ViewIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
    ];

    return (
        <>
            <Helmet>
                <title> ASN </title>
            </Helmet>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT06</p>}
                <Typography variant="h4" gutterBottom>
                    ASN Details
                </Typography>
                <Card>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} lg={4}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Consignment Status</InputLabel>
                                    <Select label='Consignment Status' name="consignmentStatus" value={searchFilter.consignmentStatus || ''} onChange={(e) => handleChange(e)}>
                                        <MenuItem value=''>Select</MenuItem>
                                        {consignmentStatusList &&
                                            consignmentStatusList.map((status) => (
                                                <MenuItem value={status}>{status}</MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={3}>
                                <FormControl fullWidth >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="ASN From Date"
                                            inputFormat="DD/MM/YYYY"
                                            value={searchFilter?.fromDate ? dayjs(searchFilter.fromDate) : null}
                                            maxDate={searchFilter?.toDate ? dayjs(searchFilter.toDate) : dayjs()}
                                            onChange={(value) => handleDateChange(value, "fromDate")}
                                            renderInput={(params) => (
                                                <TextField {...params} size="small" fullWidth />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={3}>
                                <FormControl fullWidth >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="ASN To Date"
                                            inputFormat="DD/MM/YYYY"
                                            value={searchFilter?.toDate ? dayjs(searchFilter.toDate) : null}
                                            minDate={searchFilter?.fromDate ? dayjs(searchFilter.fromDate) : undefined}
                                            maxDate={dayjs()}
                                            onChange={(value) => handleDateChange(value, "toDate")}
                                            renderInput={(params) => (
                                                <TextField {...params} size="small" fullWidth />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={2}>
                                <Button startIcon={<CloseIcon />} variant="outlined" color="primary" onClick={(e) => clearSearch(e)} >
                                    Clear Search
                                </Button>
                                {/* <Button startIcon={<SearchIcon />} variant="contained" color="primary" onClick={(e) => searchAsnDetails(e)}>Search</Button> */}
                            </Grid>
                        </Grid>
                        <TabContext value={tabValue}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleTabChange}>
                                    <Tab label="Raw Bamboo" value="RawBamboo" />
                                    <Tab label="Chip Bamboo" value="ChipBamboo" />
                                </TabList>
                            </Box>
                            <TabPanel value="RawBamboo">
                                <Box style={{ height: 500, width: '100%' }}>
                                    {
                                        asnDetails &&
                                        <DataGrid rows={asnDetails}
                                            rowCount={rowCount}
                                            rowsPerPageOptions={[10, 20, 50, 100]}
                                            columns={columns}
                                            page={page}
                                            pageSize={pageSize}
                                            paginationMode="server"
                                            onPageChange={(newPage) => {
                                                setPage(newPage);
                                                getAsnDetails('RawBamboo', newPage, pageSize, sortField, sortOrder, searchText);
                                            }}
                                            onPageSizeChange={(newPageSize) => {
                                                setPageSize(newPageSize);
                                                getAsnDetails('RawBamboo', page, newPageSize, sortField, sortOrder, searchText);
                                            }}
                                            components={{ Toolbar: CustomDataGridToolbarServer }}
                                            componentsProps={{ toolbar: { columns: columns, onSearch: fetchSearchData, onFetchData: fetchData, fileName: "ASN_RB.xlsx", dateFields: ['asnDate'] } }}
                                        />
                                    }
                                </Box>
                            </TabPanel>
                            <TabPanel value="ChipBamboo">
                                <Box style={{ height: 500, width: '100%' }}>
                                    {
                                        asnDetails &&
                                        <DataGrid rows={asnDetails}
                                            rowCount={rowCount}
                                            rowsPerPageOptions={[10, 20, 50, 100]}
                                            columns={columns}
                                            page={page}
                                            pageSize={pageSize}
                                            paginationMode="server"
                                            onPageChange={(newPage) => {
                                                setPage(newPage);
                                                getAsnDetails('ChipBamboo', newPage, pageSize, sortField, sortOrder, searchText);
                                            }}
                                            onPageSizeChange={(newPageSize) => {
                                                setPageSize(newPageSize);
                                                getAsnDetails('ChipBamboo', page, newPageSize, sortField, sortOrder, searchText);
                                            }}
                                            components={{ Toolbar: CustomDataGridToolbarServer }}
                                            componentsProps={{ toolbar: { columns: columns, onSearch: fetchSearchData, onFetchData: fetchData, fileName: "ASN_CB.xlsx", dateFields: ['asnDate'] } }}
                                        />
                                    }
                                </Box>
                            </TabPanel>
                        </TabContext>
                    </CardContent>
                </Card>
            </Container>
        </>
    );
}
export default AsnGrn;
